import { AvatarSize } from "@amzn/stencil-react-components/avatar";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { RoundedAvatar } from "@amzn/it-shop-shared-components";
import React, { FC } from "react";

import { MessageItemProps } from "./order-messages-flyout.types";
import { UserPermissions } from "@/services/user-permissions/user-permissions";

function formatTimestamp(timestamp: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(new Date(timestamp));
}

export const MessageItem: FC<MessageItemProps> = ({ username, timestamp, message, className }) => {
  const currentUsername = UserPermissions.current.username;
  const displayName = username !== currentUsername ? "Procurement team" : "You";

  return (
    <Row className={className} data-testid="message-item">
      <Col padding={{ top: "S400", bottom: "S400" }} width="100%">
        <Row justifyContent="space-between" alignItems="center" gridGap={32}>
          <RoundedAvatar
            username={username}
            size={AvatarSize.Small}
            showUsername={false}
            fullName={displayName}
            renderNameWrapper={(name) => <Text fontWeight="medium" data-testid="message-author">{name}</Text>}
            showImage={true}
          />
          <Text color="gray" fontSize="T100" data-testid="message-timestamp">
            {formatTimestamp(timestamp)}
          </Text>
        </Row>
        <Row padding={{ left: "40px", top: "S400" }}>
          <Text data-testid="message-content">{message}</Text>
        </Row>
      </Col>
    </Row>
  );
};
